import { LayoutLoading } from 'components/LayoutLoading'
import { useEffect, useMemo, useState } from 'react'
import { getAdminConfig } from 'services'
import { PlainTable } from 'stories/components'

export interface IHmdaConversionEntry {
  num: number
  placeholder: string
  excelTitle?: string
  note?: string
  codes?: Record<string, string>
}

const renderCodeTable = (map?: Record<string, string>) => {
  if (!map || !Object.keys(map).length) return <span className="text-xs text-gray-400">=</span>
  return (
    <table className="text-xs">
      <tbody>
        {Object.keys(map).map((key) => (
          <tr key={key}>
            <td className="border-b pr-2 border-r whitespace-nowrap">{key}</td>
            <td className="border-b pl-2 whitespace-nowrap">{map[key]}</td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}

export const HmdaConversionConfiguration = () => {
  const [isLoading, setLoading] = useState(true)
  const [fields, setFields] = useState<IHmdaConversionEntry[]>([])

  useEffect(() => {
    getAdminConfig('hmdaConversion')
      .then(({ fields }: { fields: IHmdaConversionEntry[] }) => setFields(fields || []))
      .finally(() => setLoading(false))
  }, [])

  const tableData = useMemo(() => {
    return fields.map((entry) => {
      const displayTitle = entry.excelTitle ? `${entry.excelTitle} (${entry.placeholder})` : entry.placeholder
      return [entry.num, displayTitle, renderCodeTable(entry.codes)]
    })
  }, [fields])

  return (
    <div className="relative">
      <LayoutLoading show={isLoading} />
      <p className="text-sm text-gray-500 mb-2">
        Read-only mapping used by the HMDA Report (<code className="text-xs">/reports/hmda</code>) to convert system
        values to HMDA submission codes. Sourced from the official HMDA Conversion Template.
      </p>
      <PlainTable
        thClass="!px-4"
        tdClass="px-4 py-2 align-top"
        header={['#', 'Field', 'Data Mapping']}
        data={tableData}
      />
    </div>
  )
}
